import { render } from "./UnderConst.vue?vue&type=template&id=a4fa8246"
import script from "./UnderConst.vue?vue&type=script&lang=js"
export * from "./UnderConst.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__